<div class="panel-state" [class.panel-state--compact]="compact" [class.panel-state--banner]="isBanner" [attr.role]="isError ? 'alert' : null">
  <div class="panel-state-icon">
    <svg-icon [src]="resolvedIcon" svgClass="panel-state-svg-icon" [title]="isError ? '' : title" [attr.aria-hidden]="isError ? 'true' : null" />
  </div>

  <div class="panel-state-text">
    <h3 class="panel-state-title">{{ title }}</h3>
    <p class="panel-state-message" *ngIf="isError && message">{{ message }}</p>
  </div>

  <button class="panel-state-retry" *ngIf="isError" nz-button nzType="default" nzShape="round" (click)="retry$.emit()">
    <svg-icon src="assets/icons/arrow-rotate-anticlockwise.svg" class="panel-state-retry-icon" aria-hidden="true"></svg-icon>
    Try again
  </button>
</div>
